import { render, staticRenderFns } from "./PrintItemHolder.vue?vue&type=template&id=449128e6&scoped=true&"
import script from "./PrintItemHolder.vue?vue&type=script&lang=js&"
export * from "./PrintItemHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449128e6",
  null
  
)

export default component.exports